export const UZS = 'UZS'
export const USD = 'USD'
